module Bookhus {

    interface IHouseInformation {
        total: number;
        page: number;
        items: IHouse[];
    }

    interface IHouse {
        id: number;
        imageId: string;
        title: string;
        imageCopyright: string;
        domain: string;
        companyName: string;
        encryptedData: string;
    }

    enum BookhusChannelFilter {
        All,
        IncludeOnlyOwnProperties,
        IncludeOnlyExternalProperties
    }

    export class HouseTeaserCarouselManager {

        private carouselContainer: JQuery;
        private itemContainer: JQuery;
        private contentSlider: JQuery;

        private currentSegment: number;
        private segmentSize: number;
        private totalSegments: number;

        private currentItemOffset: number;
        private itemWidth: number;
        private minItemWidth: number = 294;

        private bookhusChannelFilter: BookhusChannelFilter = BookhusChannelFilter.All;

        constructor() {

        }

        public init(target: Element): void {
            var self = this;

            self.carouselContainer = $(target as HTMLElement);
            if (self.carouselContainer == null || self.carouselContainer.length == 0) {
                return;
            }

            self.itemContainer = self.carouselContainer.find('.itemContainer');
            if (self.itemContainer == null || self.itemContainer.length == 0) {
                return;
            }

            self.contentSlider = self.carouselContainer.find('.itemContainer .contentSlider');
            if (self.contentSlider == null || self.contentSlider.length == 0) {
                return;
            }

            var showOwnProperties = self.carouselContainer.data('showownproperties') == 'ja';
            var showExternalProperties = self.carouselContainer.data('showexternalproperties') == 'ja';

            if (!showOwnProperties && !showExternalProperties) {
                return;
            }

            if (showOwnProperties && !showExternalProperties) {
                self.bookhusChannelFilter = BookhusChannelFilter.IncludeOnlyOwnProperties;
            }
            else if (showExternalProperties && !showOwnProperties) {
                self.bookhusChannelFilter = BookhusChannelFilter.IncludeOnlyExternalProperties;
            }


            self.segmentSize = 4;
            self.itemWidth = self.calculateItemWidth(self.segmentSize);

            self.currentItemOffset = 0;
            self.currentSegment = 0;
            self.totalSegments = 1;

            self.loadNextSegment();
            self.initEvents();
        }

        private loadNextSegment(callback: () => void = null) {
            var self = this;

            if (self.currentSegment >= self.totalSegments) {
                return;
            }

            var nextSegment = self.currentSegment + 1;

            var ajax = $.ajax({
                url: '/api/houseteasercarousel/gethouses',
                type: 'get',
                dataType: 'json',
                data: {
                    page: nextSegment,
                    pageSize: self.segmentSize,
                    bookhusChannelFilter: self.bookhusChannelFilter
                }
            });

            ajax.then((itemInformation: IHouseInformation) => {
                self.currentSegment = nextSegment;
                self.totalSegments = Math.ceil(itemInformation.total / self.segmentSize);
                self.drawSegment(itemInformation.items);
                if (typeof (callback) == "function") {
                    callback();
                }
            });

            ajax.fail(() => {
                self.drawEmptySegment();
            });
        }

        private drawSegment(items: IHouse[]) {
            var self = this;

            for (var index = 0; index < items.length; index++) {
                var current = items[index];

                var url = "";
                if (current.domain != null && current.domain.length > 0) {
                    url = "http://" + current.domain;
                }

                var item = $(`
                    <div class="col-md-3" style="width: ${self.itemWidth}px; max-width: none;">
                		<div class="spot brand-background-transparent">
                			<div class="spot-photo" style="background-image: url(${url}/houseimage/${current.imageId}/280)"></div>
                            <div class="gallery-copyright">${current.imageCopyright}</div>
                			<div class="spot-info"">
                				<h1>${current.title}</h1>
                			</div>
                            <div class="spot-price">
                			    <a href="${url}/book/${current.id}" class="btn btn-light btn-sm" data-bookhusportal="${url.length > 0 ? 'show' : ''}" data-propertyowner="${current.companyName}" data-encrypteddata="${current.encryptedData}" data-redirectto="/book/${current.id}" aria-label="Vis mere information om ${current.title}">Book</a>
                		        <a href="${url}/house/${current.id}" class="btn btn-light btn-sm" data-bookhusportal="${url.length > 0 ? 'show' : ''}" data-propertyowner="${current.companyName}" data-encrypteddata="${current.encryptedData}" data-redirectto="/book/${current.id}" aria-label="Gå videre med booking af ${current.title}">Info</a>
                		    </div>
                		</div>
                	</div>
                `);
                self.contentSlider.append(item);
            }
        }

        private drawEmptySegment(): void {
            var self = this;
            self.contentSlider.html(`
                <div class="col-md-3" style="width: ${self.itemWidth}px">
                    Ingen emner fundet.
                </div>
            `);
            self.currentItemOffset = 0;
            self.contentSlider.animate({ marginLeft: -self.convertItemOffsetToWidth(0) }, 500);
        }

        initEvents(): void {
            var self = this;
            self.carouselContainer.find('.nav-arrow-left').on('click', () => {
                self.MoveToNextItem(-1);
            });

            self.carouselContainer.find('.nav-arrow-right').on('click', () => {
                self.MoveToNextItem(1);
            });

            $(window).on('resize', self.debounce(() => { self.resizeSegment(); }, 50, false));
        }

        private tryParse(input: string, defaultValue: number): number {
            if (input != null || input != undefined || input.length != 0) {
                var result = parseInt(input);
                if (!isNaN(result)) {
                    return result;
                }
            }
            return defaultValue;
        }

        private IsThereMoreItemsToShow(): boolean {
            var self = this;

            var widthOfEachSegment = self.itemWidth * self.segmentSize;
            var totalWidthOfLoadedSegments = self.currentSegment * widthOfEachSegment;

            //If last segment and not full, subtract missing items
            if (self.currentSegment == self.totalSegments) {
                var missingItems = self.currentSegment * self.segmentSize - self.contentSlider.children('.col-md-3').length;
                if (missingItems > 0) {
                    totalWidthOfLoadedSegments -= missingItems * self.itemWidth;
                }
            }

            return totalWidthOfLoadedSegments - (self.convertItemOffsetToWidth(self.currentItemOffset) + widthOfEachSegment) > 0;
        }

        private IsThereMoreSegmentsToLoad(): boolean {
            var self = this;
            return self.currentSegment < self.totalSegments;
        }

        private MoveToNextItem(direction: number): void {
            var self = this;

            if (self.contentSlider.is(':animated')) {
                return;
            }

            var newItemOffset = self.currentItemOffset + direction;
            if (newItemOffset < 0) {
                return;
            }

            //We only want to do these cheks if we're moving forward
            if (direction > 0 && !self.IsThereMoreItemsToShow()) {
                if (self.IsThereMoreSegmentsToLoad()) {
                    self.loadNextSegment(() => {
                        self.MoveToNextItem(direction);
                    });
                    return;
                }
                newItemOffset = 0;
            }

            self.currentItemOffset = newItemOffset;
            self.contentSlider.animate({ marginLeft: -self.convertItemOffsetToWidth(newItemOffset) }, 500);
        }

        private convertItemOffsetToWidth(itemOffset: number): number {
            var self = this;
            return itemOffset * self.itemWidth;
        }

        private resizeSegment(): void {
            var self = this;
            self.itemWidth = self.calculateItemWidth(self.segmentSize);
            self.contentSlider.children('div.col-md-3').css('width', self.itemWidth);
            self.contentSlider.animate({ marginLeft: -self.convertItemOffsetToWidth(self.currentItemOffset) }, 500);
        }

        private calculateItemWidth(maxDisplayableItems: number): number {
            var self = this;
            var itemWidth = Math.floor(self.itemContainer.width() / maxDisplayableItems);
            if (itemWidth < self.minItemWidth && maxDisplayableItems > 1) {
                return self.calculateItemWidth(--maxDisplayableItems);
            }
            return itemWidth;
        }

        private debounce(func, wait, immediate) {
            var timeout;
            return function () {
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }
    }
}

$('.houseTeaserCarousel').each((index, element) => {
    var carouselItemManager = new Bookhus.HouseTeaserCarouselManager();
    carouselItemManager.init(element);
});
